import { useCallback, type MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Enables hash-anchor section navigation across pages.
 * On the home page the native anchor scroll is used;
 * on any inner page we navigate back home carrying the target section id.
 */
export function useSectionNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const goToSection = useCallback(
    (event: MouseEvent<HTMLAnchorElement>, href: string) => {
      if (isHome) return;
      event.preventDefault();
      navigate('/', { state: { scrollTo: href.replace('#', '') } });
    },
    [isHome, navigate],
  );

  return { isHome, goToSection };
}